export interface BuildFlowResolvedDetail {
  ok?: boolean;
  clickId?: string | null;
  reason?: string;
}

/** Only a scoped success can finalize a persisted build-button decision. */
export const isSuccessfulBuildResolution = (
  detail: BuildFlowResolvedDetail,
  expectedClickId: string | null,
): boolean => Boolean(
  detail.ok === true
  && detail.clickId
  && detail.clickId === expectedClickId,
);
